"use client";
import { useState } from "react";
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import DatasetDS from "../../../DataServices/DatasetDs";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

function AddDatasetLogic({ onCancel, onSave, acroFieldsList }) {

  const useremail = localStorage.getItem("email");
  const { showAlert, hud, stopHudRotation } = useCustomContext();
  const ds = new DatasetDS();

  const [datasetID, setDatasetID] = useState("");
  const [datasetName, setDatasetName] = useState("");
  const [datasetDisplayName, setDatasetDisplayName] = useState("");
  const [state, setState] = useState("");

  // 🔹 NEW
  const [entryType, setEntryType] = useState("Request Based PDF Entry"); // REQUEST | COUNTER
  const [objectType, setObjectType] = useState(""); // GROUPED | INDIVIDUAL

  const [zohoDepartmentID, setZohoDepartmentID] = useState("");
  const [replyToEmail, setReplyToEmail] = useState("");
  const [smtpFromEmail, setSmtpFromEmail] = useState("");
  const [smtpSubject, setSmtpSubject] = useState("");
  const [universalFormFile, setUniversalFormFile] = useState(null);
  const [dailyEntryLimit, setDailyEntryLimit] = useState("");
  const [qaCompletionDays, setQaCompletionDays] = useState("");
  const [ignoredFileApprovalDays, setIgnoredFileApprovalDays] = useState("");
  const [datasetOPRARequestSendEnable, setDatasetOPRARequestSendEnable] = useState(false);
  // const [fromRange, setFromRange] = useState("");
  // const [toRange, setToRange] = useState("");

  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    switch (name) {
      case "datasetID":

        if (value.length > 50) {
          setErrors((prev) => ({
            ...prev,
            datasetID: "Dataset ID cannot exceed 50 characters",
          }));
          return;
        }

        setErrors((prev) => ({
          ...prev,
          datasetID: "",
        }));

        setDatasetID(value);
        break;

      case "datasetName":

        if (value.length > 50) {
          setErrors((prev) => ({
            ...prev,
            datasetName: "Dataset Name cannot exceed 50 characters",
          }));
          return;
        }

        setErrors((prev) => ({
          ...prev,
          datasetName: "",
        }));

        setDatasetName(value);
        break;

      case "datasetDisplayName":

        if (value.length > 50) {
          setErrors((prev) => ({
            ...prev,
            datasetDisplayName: "Display Name cannot exceed 50 characters",
          }));
          return;
        }

        setErrors((prev) => ({
          ...prev,
          datasetDisplayName: "",
        }));

        setDatasetDisplayName(value);
        break;
      case "state":
        setState(value);
        break;

      // 🔹 ENTRY TYPE
      case "entryType":
        setEntryType(value);

        if (value === "Counter Based WebSite Entry" || value === "Date Range Based PDF Entry") {
          setObjectType("Grouped Object");
        } else {
          setObjectType("");
        }

        setReplyToEmail("");
        setSmtpFromEmail("");
        setSmtpSubject("");
        // setFromRange("");
        // setToRange("");
        break;


      // 🔹 OBJECT TYPE
      case "objectType":
        setObjectType(value);
        break;

      // case "fromRange":
      //   if (value === "" || Number(value) <= 0) {
      //     setFromRange(value);
      //   }
      //   break;

      // case "toRange":
      //   if (value === "" || Number(value) <= 0) {
      //     setToRange(value);
      //   }
      //   break;

      case "zohoDepartmentID":
        setZohoDepartmentID(value);
        break;

      case "replyToEmail":
        setReplyToEmail(value);
        break;

      case "smtpFromEmail":
        setSmtpFromEmail(value);
        break;

      case "smtpSubject":
        setSmtpSubject(value);
        break;
      case "dailyEntryLimit": {
        const num = value === "" ? "" : Number(value);
        if (value !== "" && (isNaN(num) || num < 0)) return;
        setDailyEntryLimit(value === "" ? "" : num);
        break;
      }
      case "qaCompletionDays": {
        const num = value === "" ? "" : Number(value);
        if (value !== "" && (isNaN(num) || num < 0 || num > 9)) return;
        setQaCompletionDays(value === "" ? "" : num);
        break;
      }
      case "ignoredFileApprovalDays": {
        const num = value === "" ? "" : Number(value);
        if (value !== "" && (isNaN(num) || num < 0 || num > 9)) return;
        setIgnoredFileApprovalDays(value === "" ? "" : num);
        break;
      }
      case "datasetOPRARequestSendEnable":
        setDatasetOPRARequestSendEnable(e.target.checked);
        return;
      default:
        break;
    }
  };

  const validateFields = () => {
    let newErrors = {};

    if (!datasetID.trim()) newErrors.datasetID = "Dataset ID is required";
    if (!datasetName.trim()) newErrors.datasetName = "Dataset Name is required";
    if (!datasetDisplayName.trim())
      newErrors.datasetDisplayName = "Display Name is required";
    if (!state.trim()) newErrors.state = "State is required";

    // 🔹 REQUEST BASED VALIDATION

    if (entryType === "Request Based PDF Entry") {
      if (!replyToEmail.trim())
        newErrors.replyToEmail = "Reply To Email is required";
      else if (!emailRegex.test(replyToEmail))
        newErrors.replyToEmail = "Enter a valid email";

      if (!smtpFromEmail.trim())
        newErrors.smtpFromEmail = "From Email is required";
      else if (!emailRegex.test(smtpFromEmail))
        newErrors.smtpFromEmail = "Enter valid email";

      // if (!smtpSubject.trim())
      //   newErrors.smtpSubject = "Subject is required";
    }

    // 🔹 COUNTER BASED VALIDATION
    if (entryType === "Counter Based WebSite Entry" && !objectType) {
      newErrors.objectType = "Object Type is required";
    }
    if (entryType === "Date Range Based PDF Entry" && !objectType) {
      newErrors.objectType = "Object Type is required";
    }

    // if (entryType === "Date Range Based PDF Entry") {
    //   if (!fromRange) newErrors.fromRange = "From range is required";

    //   if (!toRange) newErrors.toRange = "To range is required";

    //   if (fromRange !== "" && toRange !== "") {
    //     const from = Number(fromRange);
    //     const to = Number(toRange);

    //     if (from > to) {
    //       newErrors.fromRange = "From range should not be greater than To range";
    //       newErrors.toRange = "To range should be greater than or equal to From range";
    //     }
    //   }
    // }

    setErrors(newErrors);
    return newErrors;
  };
  const normalizeValue = (value = "") =>
    value.trim().replace(/\s+/g, " ");

  const uploadUniversalForm = async (file, datasetID) => {
    const idToken = localStorage.getItem("idToken");

    const s3 = new S3Client({
      region: process.env.REACT_APP_AWS_REGION,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: process.env.REACT_APP_AWS_REGION },
        identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
        logins: {
          [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
            idToken,
        },
      }),
    });

    //  Dynamic bucket name + console check before upload
    const bucketName = `${datasetID.toLowerCase()}-${datasetName.trim().replace(/\s+/g, "-").toLowerCase()}-files-${process.env.REACT_APP_ALIAS}`;
    console.log("Bucket Name:", bucketName);

    const s3Key = `UniversalForm.pdf`;
    const command = new PutObjectCommand({
      Bucket: bucketName,  //  Replaced process.env.REACT_APP_S3_BUCKET_NAME
      Key: s3Key,
      Body: await file.arrayBuffer(),
      ContentType: "application/pdf",
    });

    await s3.send(command);
    return s3Key;
  };


  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        resolve(base64);
      };

      reader.onerror = (error) => reject(error);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) return;
    const payload = {
      datasetID: normalizeValue(datasetID),
      datasetName: normalizeValue(datasetName),
      datasetDisplayName: normalizeValue(datasetDisplayName),
      state: normalizeValue(state),
      entryType,
      created_by_email_id: useremail
    };
    if (entryType === "Request Based PDF Entry") {
      // payload.zohoDepartmentID = normalizeValue(zohoDepartmentID);
      
      payload.datasetOPRARequestSendEnable = datasetOPRARequestSendEnable;

      payload.smtpSettings = {
        fromEmail: normalizeValue(smtpFromEmail),
        replyToEmail: normalizeValue(replyToEmail),
        subject: normalizeValue(smtpSubject),
      };
    }
    payload.thresholds = {
      dailyEntryLimit: dailyEntryLimit === "" ? 0 : Number(dailyEntryLimit),
      qaCompletionDays: qaCompletionDays === "" ? 0 : Number(qaCompletionDays),
      ignoredFileApprovalDays: ignoredFileApprovalDays === "" ? 0 : Number(ignoredFileApprovalDays),
    };
    if (entryType === "Counter Based WebSite Entry") {
      payload.objectType = objectType;
    }

    if (entryType === "Date Range Based PDF Entry") {
      payload.objectType = objectType;
      // payload.dateRange = {
      //   from: Number(fromRange),
      //   to: Number(toRange),
      // };
    }

    try {
      const acroFieldsObject = {};

      (acroFieldsList || []).forEach((item) => {
        if (item.key?.trim()) {
          acroFieldsObject[item.key.trim()] = item.value;
        }
      });

      if (entryType === "Request Based PDF Entry") {


        payload.pdfForm = {
          base64File: "",
          fileName: universalFormFile?.name || "",
          acroFields: acroFieldsObject,
        };

        if (universalFormFile) {
          try {

           const base64File = await convertFileToBase64(universalFormFile);

           payload.pdfForm.base64File = base64File;

          }
          catch (error) {
            console.error("PDF Conversion Failed:", error);

            stopHudRotation();

            showAlert(
              "Failed to convert PDF file.",
              [
                {
                  label: "Ok",
                  color: "red",
                  onClick: () => { },
                },
              ]
            );

            // showAlert(
            //   "PDF upload failed, Dataset will be saved without the file. Contact Your administrator.",
            //   [
            //     {
            //       label: "OK",
            //       color: "red",
            //       onClick: async () => {
            //         try {
            //           hud("Saving dataset...");

            //           const response = await ds.AP_Dataset_INSERT(payload);

            //           if (response.data?.statusCode === 200) {
            //             if (onSave) onSave(payload, true, false);
            //           } else {
            //             const body = JSON.parse(response.data.body || "{}");

            //             showAlert(body.message || "Failed to save dataset", [
            //               {
            //                 label: "OK",
            //                 onClick: () => { },
            //                 color: "red",
            //               },
            //             ]);
            //           }
            //         } catch (err) {
            //           showAlert("Error saving dataset.", [
            //             {
            //               label: "OK",
            //               onClick: () => { },
            //               color: "red",
            //             },
            //           ]);
            //         } finally {
            //           stopHudRotation();
            //         }
            //       },
            //     },
            //   ]
            // );

            return;
          }
        }
      }
      console.log("DatasetPaylod", payload);
      hud("Saving dataset...");

     // const response = await ds.AP_Dataset_INSERT(payload);

      const response = await ds.WS_Dataset_Bucket_CREATE(payload);

      if (response.data?.statusCode === 200) {
        if (onSave) onSave(payload, true, !!universalFormFile);
      } else {
        const body = JSON.parse(response.data.body || "{}");
        showAlert(body.message || "Failed to save dataset", [
          { label: "OK", onClick: () => { }, color: "red" },
        ]);
      }
    } catch (error) {
      showAlert("Error saving dataset.", [
        { label: "OK", onClick: () => { }, color: "red" },
      ]);
    } finally {
      stopHudRotation();
    }
  };

  return {
    datasetID,
    datasetName,
    datasetDisplayName,
    state,
    entryType,
    objectType,
    zohoDepartmentID,
    replyToEmail,
    datasetOPRARequestSendEnable,
    smtpFromEmail,
    smtpSubject,
    // fromRange,
    // toRange,
    errors,
    handleChange,
    handleSubmit,
    setUniversalFormFile,
    dailyEntryLimit,
    qaCompletionDays,
    ignoredFileApprovalDays,
  };
}

export default AddDatasetLogic;
